// src/App.js

import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Dashboard from "./components/Dashboard";
import Login from "./components/Login";
import KaraWorkoutPage from "./components/KaraWorkoutPage";
import VioletDreamJournal from "./components/VioletDreamJournal";
import ChatGPTNews from "./components/ChatGPTNews";
import IanaSimZone from "./components/IanaSimZone";
function App() {
  const [authToken, setAuthToken] = useState(localStorage.getItem("authToken"));

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    setAuthToken(null);
  };

  const handleLogin = (token) => {
    localStorage.setItem("authToken", token);
    setAuthToken(token);
  };

  if (!authToken) {
    return <Login onLogin={handleLogin} />;
  }

  return (
    <Router>
      <Navbar onLogout={handleLogout} />
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/karas-workouts" element={<KaraWorkoutPage />} />
        <Route path="/violet-dream-journal" element={<VioletDreamJournal />} />
        <Route path="/chatgpts-news" element={<ChatGPTNews />} />
        <Route path="/iana-simzone" element={<IanaSimZone />} />
      </Routes>
    </Router>
  );
}

export default App;
